import type TestProjectDashboardStore from '../stores/TestProjectDashboardStore';
import type { TestProjectInputEditorSource } from '../models/TestProjectInputEditorDraft';

// Capture the Dashboard selection when opening; navigation invalidates only that editor draft.
export function dashboardInputEditorSource(dashboard: TestProjectDashboardStore): TestProjectInputEditorSource {
    const dataStore = dashboard.testProjectDataStore;

    if (!dataStore) {
        throw new Error('A Test Project must be selected before opening its input editor');
    }

    return {
        dataStore,
        isCurrent: () =>
            dashboard.testProjectDataStore === dataStore && dashboard.currentProject?.id === dataStore.projectId
    };
}
